import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectAppraisalSurchargeCriteriaList = createSelector(
  getSystem,
  ({ appraisalSurchargeCriteria }) => appraisalSurchargeCriteria,
);

const selectAppraisalSurchargeCriteriaValues = createSelector(
  selectAppraisalSurchargeCriteriaList,
  Object.values,
);

export const selectFilteredAppraisalSurchargeCriteria = createSelector(
  getDebouncedSearchValue,
  selectAppraisalSurchargeCriteriaValues,
  searchItems(({ name }) => [name]),
);
